import axios from "axios";
import { API } from "./client";

/**
 * User confirms which contractor folder a pending drawing should go into.
 */
export async function resolveDrawingRouting(pendingDrawingId, contractorType, versionAction = "") {
  const res = await axios.post(`${API}/drawing-routing/${pendingDrawingId}/resolve`, {
    contractor_type: contractorType,
    version_action: versionAction,
  });
  return res.data;
}

/**
 * User skips / dismisses a pending drawing routing decision.
 */
export async function dismissDrawingRouting(pendingDrawingId) {
  const res = await axios.post(`${API}/drawing-routing/${pendingDrawingId}/dismiss`);
  return res.data;
}
